module.exports = __webpack_public_path__ + "static/media/hat-wizard.ad6618bc.svg";